/** The studio's single view switch. Shown to members and owners; a reader
 *  (no author, no invite, no team admin) gets no nav (showcase only, locked).
 *  Showcase / My studio pick the data view; Members opens the invite + roster
 *  panel (an inviting member sees Create + roster; an owner additionally sees
 *  pending invites). UI affordance only — the Guardius authorizers remain
 *  authoritative. */
export type StudioView = "showcase" | "studio" | "members";

export function StudioNav({
  view,
  canAuthor,
  canManageTeam,
  canInvite,
  onChange,
}: {
  view: StudioView;
  canAuthor: boolean;
  canManageTeam: boolean;
  canInvite: boolean;
  onChange: (next: StudioView) => void;
}) {
  const showMembers = canInvite || canManageTeam;
  if (!canAuthor && !showMembers) return null; // reader: showcase only
  return (
    <div className="studio-nav" role="group" aria-label="view">
      <button type="button" aria-pressed={view === "showcase"} onClick={() => onChange("showcase")}>
        Showcase
      </button>
      {canAuthor && (
        <button type="button" aria-pressed={view === "studio"} onClick={() => onChange("studio")}>
          My studio
        </button>
      )}
      {showMembers && (
        <button type="button" aria-pressed={view === "members"} onClick={() => onChange("members")}>
          Members
        </button>
      )}
    </div>
  );
}
